<template>
  <div class="toast">
    <div>{{ tips }}</div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

export default @Component({
  props: {
    tips: {
      type: String,
      default: '',
    },
  },
})

class Layout extends Vue {
}
</script>

<style scoped lang="less">
.toast{
    min-width:100px;
    background: rgba(0,0,0,0.7);
    color: #fff;
    top: 50%;
    position: fixed;
    text-align: center;
    left: 50%;
    width: 9%;
    transform: translate(-50%,50%);
    padding:0.5vw 0;
    z-index: 100;
    border-radius: 4px;
    font-size:14px;
    z-index:10;
}
</style>
